"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _accordionModule = _interopRequireDefault(require("./accordion.module.scss"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icon = _interopRequireDefault(require("../icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Accordion = exports.Accordion = /*#__PURE__*/function (_Component) {
  function Accordion() {
    var _this;
    _classCallCheck(this, Accordion);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Accordion, [].concat(args));
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "activeBlock", void 0);
    _defineProperty(_this, "content", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "state", {
      activeBlock: _this.props.defaultActiveKey,
      activeKey: 0
    });
    _defineProperty(_this, "isStandardAccordion", function () {
      return !_this.props.functionality || _this.props.functionality === "standard";
    });
    _defineProperty(_this, "isCreateCustomisationAccordion", function () {
      return _this.props.functionality === "create-customisation";
    });
    _defineProperty(_this, "setEntered", function () {
      _this.setEventListener();
      _this.scrollToHeader();
    });
    _defineProperty(_this, "setExit", function () {
      _this.removeEventListener();
    });
    _defineProperty(_this, "getEventOptions", function () {
      return _this.document.querySelectorAll("[data-setaccordionkey]");
    });
    _defineProperty(_this, "setAccordionKey", function (e) {
      if (e.currentTarget.getAttribute("data-disabled") !== "true") {
        _this.setActive(e.currentTarget.getAttribute("data-setaccordionkey"));
        _this.setEventListener();
      }
    });
    _defineProperty(_this, "getActive", function (child, key) {
      var _child$props;
      if ((child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) === _this.activeBlock) {
        return key;
      } else {
        return null;
      }
    });
    _defineProperty(_this, "toggleBlock", function (event) {
      var block = event.currentTarget.getAttribute("data-block");
      if (block === _this.state.activeBlock && _this.state.activeBlock !== null) {
        _this.setActive(null);
      } else {
        _this.setActive(block);
      }
    });
    _defineProperty(_this, "renderToggleOrEdit", function (child, key, iconType) {
      if (_this.isCreateCustomisationAccordion()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _accordionModule["default"].edit
        }, _this.props.backText);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _accordionModule["default"].toggle
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        type: iconType
      }));
    });
    _defineProperty(_this, "getPropsForBlockHeader", function (child, key) {
      var props = {};
      if (_this.isCreateCustomisationAccordion()) {
        props = {
          "data-setaccordionkey": _this.getAccordionKey(child, key)
        };
      } else if (_this.isStandardAccordion()) {
        props = {
          onClick: _this.toggleBlock,
          "data-block": child.props.eventKey
        };
      }
      return props;
    });
    _defineProperty(_this, "renderChild", function (child, key) {
      if (!(child !== null && child !== void 0 && child.props)) {
        return null;
      }
      var isActive = _this.isActive(child.props.eventKey);
      var nodeRef = isActive ? _this.content : /*#__PURE__*/_react["default"].createRef();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _this.getBlockStyles(isActive, key)
      }, _this.renderBlockHeader(child, key, isActive), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        key: child.props.eventKey,
        nodeRef: nodeRef,
        "in": isActive,
        timeout: 1000,
        onEntered: _this.setEntered,
        onExit: _this.setExit,
        appear: true,
        unmountOnExit: true,
        classNames: "transition-accordion"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _accordionModule["default"].content,
        ref: nodeRef
      }, child)));
    });
    return _this;
  }
  _inherits(Accordion, _Component);
  return _createClass(Accordion, [{
    key: "setEventListener",
    value: function setEventListener() {
      var _this2 = this;
      this.getEventOptions().forEach(function (item) {
        item.addEventListener("click", _this2.setAccordionKey, false);
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {
      var _this3 = this;
      this.getEventOptions().forEach(function (item) {
        item.removeEventListener("click", _this3.setAccordionKey);
      });
    }
  }, {
    key: "setActive",
    value: function setActive(activeBlock) {
      /**
       * Create Customisation does not allow a step to be closed without opening another.
       * This could sometimes be triggered by double-clicking on a header.
       * It would start the open transition then cancel it and leave the user stuck
       * with all steps closed and no interactable elements.
       */
      if (activeBlock === null && this.isCreateCustomisationAccordion()) {
        return null;
      }
      this.activeBlock = activeBlock;
      if (this.activeBlock !== this.state.activeBlock) {
        this.props.onChange && this.props.onChange(this.activeBlock);
        var activeKey = this.getActiveBlockKey();
        this.setState({
          activeBlock: activeBlock,
          activeKey: activeKey
        });
      }
    }
  }, {
    key: "isActive",
    value: function isActive(eventKey) {
      return this.state.activeBlock === eventKey;
    }
  }, {
    key: "getBlockStyles",
    value: function getBlockStyles(isActive, key) {
      return "".concat(_accordionModule["default"].block, " ").concat(isActive && _accordionModule["default"].active, " ").concat((key < this.state.activeKey || this.isStandardAccordion()) && _accordionModule["default"].previous);
    }
  }, {
    key: "getBlockHeaderStyles",
    value: function getBlockHeaderStyles() {
      var _this$props$colour;
      return "".concat(_accordionModule["default"].header, " ").concat(_accordionModule["default"][(_this$props$colour = this.props.colour) === null || _this$props$colour === void 0 ? void 0 : _this$props$colour.toLowerCase()], " ").concat(this.props.headerAlign === "Center" && _accordionModule["default"].centered);
    }
  }, {
    key: "getActiveBlockKey",
    value: /* istanbul ignore next */
    function getActiveBlockKey() {
      var activeKeys = _react["default"].Children.map(this.props.children, this.getActive);
      return activeKeys.filter(function (n) {
        return n;
      })[0];
    }
  }, {
    key: "getAccordionKey",
    value: function getAccordionKey(child, key) {
      if (key < this.state.activeKey) {
        return child.props.eventKey;
      } else {
        return null;
      }
    }
  }, {
    key: "scrollToHeader",
    value: function scrollToHeader() {
      if (this.props.scrollOnChange) {
        var yOffset = this.props.scrollOffset || 0;
        var element = this.document.getElementById("header-".concat(this.state.activeBlock));
        /**
         * this.window.pageYOffset is not deprecated. This is a false positive.
         * @see https://youtrack.jetbrains.com/issue/WEB-55890/wrong-deprecated-warning-for-windowpageXoffset-and-windowpageYoffset
         */
        var y = element.getBoundingClientRect().top + this.window.pageYOffset + yOffset;
        this.window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    }
  }, {
    key: "renderBlockHeader",
    value: function renderBlockHeader(child, key, isActive) {
      var iconType = isActive ? "ChevronUp" : "ChevronDown";
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, this.getPropsForBlockHeader(child, key), {
        className: this.getBlockHeaderStyles(),
        id: "header-".concat(child.props.eventKey)
      }), /*#__PURE__*/_react["default"].createElement("div", null, child.props.title), this.renderToggleOrEdit(child, key, iconType));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _accordionModule["default"].accordion,
        "data-testid": "accordion"
      }, _react["default"].Children.map(this.props.children, this.renderChild));
    }
  }]);
}(_react.Component);
Accordion.propTypes = {
  defaultActiveKey: _propTypes["default"].string,
  backText: _propTypes["default"].string,
  scrollOnChange: _propTypes["default"].bool,
  scrollOffset: _propTypes["default"].number,
  functionality: _propTypes["default"].oneOf(["standard", "create-customisation"]),
  colour: _propTypes["default"].oneOf(["None", "Blue", "LightBlue"]),
  headerAlign: _propTypes["default"].oneOf(["Left", "Center"])
};
Accordion.defaultProps = {
  defaultActiveKey: "",
  backText: "Edit",
  scrollOnChange: false,
  scrollOffset: 0,
  functionality: "standard",
  colour: "Blue",
  headerAlign: "Left"
};
var _default = exports["default"] = Accordion;